module.exports = __webpack_public_path__ + "static/media/protection_personnelle.178cfb49.png";